export const eventMap = {
  id: 0, homeName: 1, awayName: 2, lines: 3, 
  time: 4, running: 5, live: 6, moreBets: 7, 
  periods: 8, scores: 9, redCards: 10, teamType: 11, 
  baseBall: 12, homePitcher: 13, awayPitcher: 14, runningTime: 15, 
  runningPeriod: 16, eventStatus: 17, liveCenter: 18, liveTV: 19, 
  liveCenterId: 20, totalMarkets: 21, parlayRestriction: 22, totalOutrightOdds: 23, 
  originalHomeName: 24, originalAwayName: 25, rotationNumber: 26
}

export const RunningState = {
  "1H": "1st Half",
  "HT": "Half Time",
  "2H": "2nd Half",
  "ER": "End of 90 mins",
  "1H ET": "ET - 1st Half",
  "HTEX": "Extra Time - HT",
  "2H ET": "ET - 2nd Half",
  "EEX": "End of Extra Time",
  "EG": "End of Game",
  "SUSP": "Suspended",
  "PEN": "Penalties"
}


// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/constants.js